<template>
  <div class="bsAttrCard">
    <div class="bsAttrCard-icon" :class="getIconClass(label)"></div>
    <h3>{{ label }}</h3>
    <p :text="value">{{ value }}</p>
  </div>
</template>

<script>
export default {
  name: "bsAttrCard",
  props: {
    label: {
      type: String,
      default: "",
    },
    value: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      iconList: [
        { text: "遥监在线", icon: "bsAttrCard-icon-01" },
        { text: "检修", icon: "bsAttrCard-icon-03" },
        { text: "故障停梯", icon: "bsAttrCard-icon-04" },
        { text: "困人", icon: "bsAttrCard-icon-02" },
        { text: "今日保养", icon: "bsAttrCard-icon-05" },
      ],
    };
  },
  methods: {
    getIconClass(label) {
      return this.iconList.find((item) => item.text === label).icon;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.bsAttrCard {
  position: relative;
  width: vw(316);
  height: vw(162);
  padding: 0 vw(20) 0 vw(110);
  display: flex;
  flex-direction: column;
  justify-content: center;
  // align-items: center;
  line-height: 1.5;
  background: url("~@/assets/img/largeScreen/bsAttrCard_bg.png") no-repeat
    center;
  background-size: 100% 100%;
  text-align: center;
  h3 {
    position: relative;
    z-index: 9;
    font-size: vw(18);
    font-weight: 500;
    font-family: AlibabaPuHuiTi;
    line-height: 1.2;
    word-break: break-all;
    margin: 0.4em 0 1.2em;
    color: var(--bs-color-text-regular);
    transition: all 0.2s ease;
  }
  p {
    position: relative;
    z-index: 9;
    font-size: vw(30);
    font-family: "DINPro";
    font-weight: 500;
    line-height: 1;
    // color: transparent;
    color: #fff;
    text-shadow: 0 0.1em 0.1em rgba(0, 0, 0, 0.45), 0 0 0.5em #3863ee;
    font-family: DINPro-Medium;
    cursor: pointer;
    display: inline-flex;
    margin: 0 auto;
    // &:after {
    //   content: attr(text);
    //   position: absolute;
    //   left: 0;
    //   z-index: 9;
    //   color: #ffffff;
    //   text-align: center;
    //   background-image: linear-gradient(to top, #AEC5FE, #ffffff);
    //   -webkit-background-clip: text;
    //   -webkit-text-fill-color: transparent;
    //   text-shadow: none;
    // }
  }
  &-icon {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: vw(150);
    height: vw(150);
    background: url("~@/assets/img/largeScreen/bsAttrCard_icon_01.png")
      no-repeat center;
    background-size: contain;
    transition: all 0.2s ease;
    &-01 {
      background: url("~@/assets/img/largeScreen/bsAttrCard_icon_01.png")
        no-repeat center;
      background-size: contain;
    }
    &-02 {
      background: url("~@/assets/img/largeScreen/bsAttrCard_icon_02.png")
        no-repeat center;
      background-size: contain;
    }
    &-03 {
      background: url("~@/assets/img/largeScreen/bsAttrCard_icon_03.png")
        no-repeat center;
      background-size: contain;
    }
    &-04 {
      background: url("~@/assets/img/largeScreen/bsAttrCard_icon_04.png")
        no-repeat center;
      background-size: contain;
    }
    &-05 {
      background: url("~@/assets/img/largeScreen/bsAttrCard_icon_05.png")
        no-repeat center;
      background-size: contain;
    }
  }
  &.is-active {
    width: vw(356);
    height: vw(182);
    padding-left: vw(124);
    // transform: scale(1.13);
    h3 {
      font-size: vw(20);
      margin-top: 0.2em;
    }
    p {
      // font-size: vw(34);
      color: transparent;
      &:after {
        content: attr(text);
        position: absolute;
        left: 0;
        z-index: 9;
        color: #ffffff;
        text-align: center;
        background-image: linear-gradient(to top, #aec5fe, #ffffff);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        text-shadow: none;
      }
    }
    .bsAttrCard-icon {
      width: vw(170);
      height: vw(170);
    }
  }
}
// @media screen and (max-width: $--lg) {
//   .bsAttrCard {
//     font-size: $--font-size-base;
//     padding: 0 1.5em;
//   }
// }
</style>
